/**
 * DatePicker - H5 版本，含 trigger + 弹窗
 */
import React, { useState } from 'react';
import { DatePicker as ZarmDatePicker } from 'zarm-v3';

export interface IsomorphicDatePickerProps {
  value?: string;
  max?: Date;
  min?: Date;
  title?: string;
  placeholder?: string;
  onOk?: (date: Date) => void;
  className?: string;
}

export const DatePicker: React.FC<IsomorphicDatePickerProps> = ({
  value,
  max = new Date(),
  min = new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
  title = '选择日期',
  placeholder = '请选择',
  onOk,
  className,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <div
        className={`za-select__value ${className || ''}`}
        onClick={() => setVisible(true)}
        role='button'
        tabIndex={0}
      >
        {value || placeholder}
      </div>
      <ZarmDatePicker
        title={title}
        visible={visible}
        value={value ? new Date(value) : undefined}
        onConfirm={(dateVal: Date) => {
          onOk?.(dateVal);
          setVisible(false);
        }}
        onCancel={() => setVisible(false)}
        min={min}
        max={max}
      />
    </>
  );
};

export default DatePicker;
